import { render, staticRenderFns } from "./SupervisorApproval.vue?vue&type=template&id=0a71bb0a&"
import script from "./SupervisorApproval.vue?vue&type=script&lang=js&"
export * from "./SupervisorApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports